<template>
  <div>
    <v-card :class="$vuetify.dark ? 'card-dark ' : 'card-light '">
      <v-progress-linear
        class="ma-0"
        height="5"
        indeterminate
        :active="networkLoader"
        color="accent"
      />
      <v-layout xs12 align-start justify-start row>
        <v-tooltip bottom>
          <v-btn class="pa-1" icon @click.stop="toggleResize" slot="activator">
            <v-icon>{{ fullSize ? 'fullscreen_exit' : 'zoom_out_map' }}</v-icon>
          </v-btn>
          <span>{{ fullSize ? 'Collapse' : 'Expand' }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <v-btn
            class="pa-1"
            icon
            :color="options.physics ? 'secondary' : ''"
            slot="activator"
            @click="tooglePhysicsLayout()"
          >
            <v-icon>waves</v-icon>
          </v-btn>
          <span>Toggle physics interactions</span>
        </v-tooltip>
        <v-tooltip bottom>
          <v-btn
            class="pa-1"
            icon
            :color="options.layout.hierarchical.enabled ? 'secondary' : ''"
            slot="activator"
            @click="toogleLayout()"
          >
            <v-icon>device_hub</v-icon>
          </v-btn>
          <span>Toggle Hub display</span>
        </v-tooltip>
        <v-tooltip bottom>
          <v-btn
            :loading="networkLoader"
            class="pa-1"
            icon
            @click.stop="refresh"
            slot="activator"
          >
            <v-icon>cached</v-icon>
          </v-btn>
          <span>Refresh</span>
        </v-tooltip>
        <v-tooltip bottom>
          <v-btn
            :loading="networkLoader"
            :disabled="disableLoadMore"
            class="pa-1"
            icon
            @click.stop="getMoreData"
            slot="activator"
          >
            <v-icon>read_more</v-icon>
          </v-btn>
          <span>Get more data</span>
        </v-tooltip>
      </v-layout>
      <v-card-text class="pa-2">
        <div ref="executionGraph" class="network"></div>
      </v-card-text>
    </v-card>
    <v-dialog
      persistent
      v-model="showModel"
      max-width="90%"
      content-class="honey-popup"
    >
      <v-card
        :key="execution.hexId + 'card-detail'"
        ref="activityProps"
        class="activity-props"
      >
        <v-toolbar dense card class="elevation-2">
          <div class="text-lg-left beez-bold ">
            Selected item details
          </div>
          <v-spacer />
          <v-tooltip bottom>
            <v-btn
              :disabled="activity !== null && activity.parentStackId === null"
              icon
              small
              class="mb-2"
              slot="activator"
              @click.stop="showParentDetails(activity.parentStackId)"
            >
              <v-icon>arrow_upward</v-icon>
            </v-btn>
            <span>Go to parent</span>
          </v-tooltip>
          <v-tooltip bottom>
            <v-btn flat icon @click="showModel = !showModel" slot="activator">
              <v-icon>close</v-icon>
            </v-btn>
            <span>Close</span>
          </v-tooltip>
        </v-toolbar>
        <v-card-text>
          <v-flex xs12 class="pt-2" v-if="activity">
            <v-card :class="$vuetify.dark ? 'card-dark ' : 'card-light '">
              <v-card-text>
                <v-layout xs12 align-start justify-center row wrap>
                  <v-flex xs12 sm6 md4>
                    Type: {{ activity.activityType }}
                  </v-flex>
                  <v-flex xs12 sm6 md4 v-if="activity.camundaProperties">
                    Workflow task id:
                    {{ activity.camundaProperties.currentActivityId }}
                  </v-flex>
                  <v-flex xs12 sm6 md4 v-if="activity.camundaProperties">
                    Workflow task name:
                    {{ activity.camundaProperties.currentActivityName }}
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
            <v-card class="pa-2">
              <v-toolbar
                dense
                card
                class="elevation-2"
                @click="showOutput = !showOutput"
              >
                <v-toolbar-title
                  class="body-2 beez-bold "
                  v-text="'Activity Data'"
                />
                <v-spacer />
                <v-btn icon small class="mb-2">
                  <v-icon
                    >{{
                      showOutput ? 'keyboard_arrow_up' : 'keyboard_arrow_down'
                    }}
                  </v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text v-if="showOutput">
                <v-flex xs12>
                  <form-generator
                    :key="activity.hexId + 'ouput-schema'"
                    :schema="schemaOutput"
                    :readonly="true"
                  />
                </v-flex>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { DataSet, Network } from 'vis-network/standalone/umd/vis-network.min'
import moment from 'moment'
import { mapState } from 'vuex'
import u from '@/utils'
import _ from 'lodash'
import FormGenerator from '@/components/common/form-generator/FormGenerator'
import axios from 'axios'

export default {
  components: { FormGenerator },
  name: 'ExecutionGraph',
  data() {
    return {
      showOutput: true,
      activities: [],
      executions: [],
      page: 0,
      size: 10,
      schemaOutput: [],
      networkInitialized: false,
      fullSize: false,
      activity: null,
      networkLoader: false,
      options: {
        physics: false,
        clickToUse: true,
        autoResize: true,
        layout: {
          randomSeed: 2,
          improvedLayout: true,
          hierarchical: {
            enabled: true,
            levelSeparation: 150,
            nodeSpacing: 100,
            treeSpacing: 200,
            blockShifting: true,
            edgeMinimization: true,
            parentCentralization: true,
            direction: 'LR', // UD, DU, LR, RL
            sortMethod: 'directed' // hubsize, directed
          }
        },
        nodes: {
          borderWidth: 5,
          size: 20,
          shadow: true,
          widthConstraint: {
            maximum: 70
          },
          color: {
            border: '#42A85F',
            background: '#42A85F',
            highlight: {
              border: '#ff9400',
              background: '#D2E5FF'
            },
            hover: {
              border: '#ff9400',
              background: '#D2E5FF'
            }
          },
          font: {
            size: 8,
            color: '#424242',
            strokeWidth: 0.2,
            strokeColor: '#424242'
          }
        },
        edges: {
          width: 1,
          widthConstraint: {
            maximum: 70
          },
          color: {
            color: '#424242',
            highlight: '#ff9400',
            hover: '#ff9400',
            inherit: 'both',
            opacity: 1.0
          },
          arrows: {
            middle: { enabled: true, scaleFactor: 1, type: 'arrow' }
          }
        },
        groups: {
          Bot: {
            shape: 'circularImage',
            image: {
              unselected: '/images/Bot.svg',
              selected: '/images/Bot.svg'
            },
            color: {
              border: '#42A85F',
              background: '#42A85F'
            },
            size: 20
          },
          BotError: {
            shape: 'circularImage',
            image: {
              unselected: '/images/Bot.svg',
              selected: '/images/Bot.svg'
            },
            color: {
              border: '#b82e24',
              background: '#b82e24'
            },
            size: 20
          },
          BotObsolete: {
            shape: 'circularImage',
            image: {
              unselected: '/images/Bot.svg',
              selected: '/images/Bot.svg'
            },
            color: {
              border: '#9E9E9E',
              background: '#9E9E9E'
            },
            size: 20
          },
          Workflow: {
            shape: 'circularImage',
            image: {
              unselected: '/images/Workflow.svg',
              selected: '/images/Workflow.svg'
            },
            color: {
              border: '#42A85F',
              background: '#42A85F'
            },
            size: 25
          },
          WorkflowError: {
            shape: 'circularImage',
            image: {
              unselected: '/images/Workflow.svg',
              selected: '/images/Workflow.svg'
            },
            color: {
              border: '#b82e24',
              background: '#b82e24'
            },
            size: 25
          },
          WorkflowElement: {
            shape: 'circularImage',
            image: {
              unselected: '/images/Workflow.svg',
              selected: '/images/Workflow.svg'
            },
            color: {
              border: '#42A85F',
              background: '#42A85F'
            },
            size: 20
          },
          Destructure: {
            shape: 'circularImage',
            image: {
              unselected: '/images/Destructure.svg',
              selected: '/images/Destructure.svg'
            },
            color: {
              border: '#42A85F',
              background: '#42A85F'
            },
            size: 20
          },
          Refactor: {
            shape: 'circularImage',
            image: {
              unselected: '/images/Refactor.svg',
              selected: '/images/Refactor.svg'
            },
            color: {
              border: '#42A85F',
              background: '#42A85F'
            },
            size: 20
          },
          Iterator: {
            shape: 'circularImage',
            image: {
              unselected: '/images/Iterator.svg',
              selected: '/images/Iterator.svg'
            },
            color: {
              border: '#42A85F',
              background: '#42A85F'
            },
            size: 20
          },
          Appender: {
            shape: 'circularImage',
            image: {
              unselected: '/images/Appender.svg',
              selected: '/images/Appender.svg'
            },
            color: {
              border: '#42A85F',
              background: '#42A85F'
            },
            size: 20
          },
          UserTask: {
            shape: 'circularImage',
            image: {
              unselected: '/images/Tasks.svg',
              selected: '/images/Tasks.svg'
            },
            color: {
              border: '#42A85F',
              background: '#42A85F'
            },
            size: 20
          }
        },
        interaction: {
          hover: true,
          selectable: true,
          multiselect: false,
          keyboard: true
        }
      },
      nodes: [],
      edges: [],
      networkData: null,
      network: null,
      nodeMap: null,
      nodeValueMap: null,
      showModel: false,
      disableLoadMore: false
    }
  },
  props: {
    execution: Object
  },
  mounted() {
    this.refresh()
  },
  methods: {
    getFormType(variable) {
      //  STRING, NUMBER, BOOLEAN, OBJECT, DATE, FILE, ARRAY - possible input options
      if (_.isArray(variable.value)) {
        return 'array'
      } else if (_.isString(variable.value)) {
        switch (variable.type) {
          case 'STRING':
            return 'text'
          case 'NUMBER':
            return 'text'
          case 'BOOLEAN':
            return 'checkbox'
          case 'DATE':
            return 'date'
          case 'FILE':
            return 'file'
          default:
            return 'text'
        }
      } else if (_.isDate(variable.value)) {
        return 'date'
      } else if (_.isNumber(variable.value)) {
        return 'text'
      } else if (_.isBoolean(variable.value)) {
        return 'checkbox'
      } else if (_.isUndefined(variable.value)) {
        return 'text'
      } else if (_.isNull(variable.value)) {
        return 'text'
      } else if (_.isObject(variable.value)) {
        return 'object'
      }
    },
    fillOutputSchema() {
      this.schemaOutput = []
      if (this.activity !== null) {
        for (let [key, value] of Object.entries(this.activity.variables)) {
          if (value) {
            this.schemaOutput.push({
              key: key,
              type: this.getFormType(value),
              options: {
                label: key,
                value: value.value
              }
            })
          }
        }
      }
    },
    tooglePhysicsLayout() {
      this.options.physics = !this.options.physics
      this.refresh()
    },
    toogleLayout() {
      this.options.layout.hierarchical.enabled = !this.options.layout
        .hierarchical.enabled
      this.refresh()
    },
    toggleResize() {
      this.fullSize = !this.fullSize
      this.drawNetwork()
    },
    stabilize() {
      this.network.stabilize()
    },
    draw: function() {
      let container = this.$refs.executionGraph
      if (container) {
        this.networkData = {
          nodes: new DataSet(this.nodes),
          edges: new DataSet(this.edges)
        }
        let containerHeight
        if (this.fullSize) {
          containerHeight = window.innerHeight * 0.8
        } else {
          containerHeight = window.innerHeight * 0.4
        }
        this.options.height = String(containerHeight)
        this.network = new Network(container, this.networkData, this.options)

        let _self = this
        this.network.on('doubleClick', function(params) {
          if (params.nodes.length === 1) {
            let stackId = _self.nodeValueMap.get(params.nodes[0].toString())
            _self.activity = _self.activities.find(
              item => item.hexId === stackId
            )
            _self.fillOutputSchema()
            _self.showModel = true
          }
        })

        this.stabilize()

        this.networkInitialized = true

        this.fillOutputSchema()
      }
    },
    showParentDetails(stackId) {
      this.activity = this.activities.find(item => item.hexId === stackId)
      this.fillOutputSchema()
    },
    async getMoreData() {
      this.page = this.page + 1
      this.networkLoader = true
      this.botExectuions = []
      if (this.execution && this.execution.state) {
        try {
          axios
            .get(
              '/api/v1/states/' +
                this.execution.state +
                `/stacks?page=${this.page}&size=${this.size}&sort=createdAt`
            )
            .then(response => {
              // append data
              if (response.data.page.totalPages === this.page) {
                this.disableLoadMore = true
              }
              this.activities = this.activities.concat(
                response.data._embedded.stacks
              )
              response.data._embedded.stacks
                .filter(item => item.activityType === 'BOT')
                .forEach(item => {
                  this.botExectuions.push(item.executionId)
                })

              axios
                .post('/api/v1/executions/getList', this.botExectuions)
                .then(response => {
                  this.executions = this.executions.concat(
                    response.data._embedded.executions
                  )
                })
                .catch(e => {
                  this.$store.dispatch('directNotification', {
                    type: 'error',
                    message: 'Unable to fetch Workflow executions',
                    description: e.response
                      ? e.response.data.message
                      : 'Unable to fetch Workflow activities',
                    timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
                  })
                })

              this.drawNetwork()
              this.networkLoader = false
            })
        } catch (e) {
          await this.$store.dispatch('directNotification', {
            type: 'error',
            message: 'Unable to fetch Workflow activities',
            description: e.response
              ? e.response.data.message
              : 'Unable to fetch Workflow activities',
            timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
          })
        }
      }
    },
    async refresh() {
      this.page = 1
      this.disableLoadMore = false
      this.networkLoader = true
      this.botExectuions = []
      if (this.execution && this.execution.state) {
        try {
          axios
            .get(
              '/api/v1/states/' +
                this.execution.state +
                `/stacks?page=${this.page}&size=${this.size}&sort=createdAt`
            )
            .then(response => {
              if (response.data.page.totalPages === this.page) {
                this.disableLoadMore = true
              }
              // get activities of type Bot
              response.data._embedded.stacks
                .filter(item => item.activityType === 'BOT')
                .forEach(item => {
                  this.botExectuions.push(item.executionId)
                })
              this.activities = response.data._embedded.stacks

              axios
                .post('/api/v1/executions/getList', this.botExectuions)
                .then(response => {
                  this.executions = response.data._embedded.executions
                })
                .catch(e => {
                  this.$store.dispatch('directNotification', {
                    type: 'error',
                    message: 'Unable to fetch Workflow executions',
                    description: e.response
                      ? e.response.data.message
                      : 'Unable to fetch Workflow activities',
                    timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
                  })
                })

              this.drawNetwork()
              this.networkLoader = false
            })
            .catch(e => {
              this.networkLoader = false
              this.$store.dispatch('directNotification', {
                type: 'error',
                message: 'Unable to fetch Workflow activities',
                description: e.response
                  ? e.response.data.message
                  : 'Unable to fetch Workflow activities',
                timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
              })
            })
        } catch (e) {
          await this.$store.dispatch('directNotification', {
            type: 'error',
            message: 'Unable to fetch Workflow activities',
            description: e.response
              ? e.response.data.message
              : 'Unable to fetch Workflow activities',
            timestamp: moment().format('DD MMM YYYY hh:mm:ss a')
          })
        }
      }
    },
    getActivityLabel(activity) {
      if (activity.activityType === 'USER_TASK') {
        return (
          'User Task (' + activity.camundaProperties.currentActivityId + ')'
        )
      } else {
        return activity.camundaProperties
          ? activity.camundaProperties.currentActivityName ||
              activity.camundaProperties.currentActivityId
          : activity.activityType
      }
    },
    drawNetwork() {
      this.networkLoader = true
      this.nodeMap = new Map()
      this.nodeValueMap = new Map()
      this.nodes = []
      this.edges = []
      // init a network
      let idCount = 0
      if (this.activities && this.activities.length > 0) {
        let activitiesLocal = u.clone(this.activities)
        activitiesLocal = activitiesLocal.sort((prev, curr) => {
          return prev.createdAt < curr.createdAt ? -1 : 1
        })
        if (activitiesLocal.length > 0) {
          activitiesLocal.forEach(activity => {
            if (activity.parentStackId === null) {
              this.nodes.push({
                id: 0,
                label: this.getActivityLabel(activity),
                title: activity.activityType,
                group: 'Workflow'
              })
              this.nodeMap.set(activity.hexId, '0')
              this.nodeValueMap.set('0', activity.hexId)
            } else {
              if (!this.nodeMap.get(activity.parentStackId)) {
                // parent node not found with the current data set, avoid creating orphan node
                return
              }
              ++idCount
              this.nodes.push({
                id: idCount,
                label: this.getActivityLabel(activity),
                title: activity.activityType,
                group: this.getGroup(activity)
              })
              this.nodeMap.set(activity.hexId, idCount.toString())
              this.nodeValueMap.set(idCount.toString(), activity.hexId)
              this.edges.push({
                from: parseInt(this.nodeMap.get(activity.parentStackId), 0),
                to: idCount
              })
            }
          })
        }
        this.draw()
      }
      this.networkLoader = false
    },
    getGroup(activity) {
      if (activity.activityType === 'BOT') {
        let execution = this.executions.filter(
          e => e.hexId === activity.executionId
        )
        if (execution && execution.length > 0) {
          if (execution[0].runStatus === 'FAILED') {
            return 'BotError'
          } else if (execution[0].runStatus === 'OBSOLETE') {
            return 'BotObsolete'
          } else {
            return 'Bot'
          }
        } else {
          return 'Bot'
        }
      } else if (activity.activityType === 'DESTRUCTURE') {
        return 'Destructure'
      } else if (activity.activityType === 'ITERATOR') {
        return 'Iterator'
      } else if (activity.activityType === 'REFACTOR') {
        return 'Refactor'
      } else if (activity.activityType === 'APPENDER') {
        return 'Appender'
      } else if (activity.activityType === 'USER_TASK') {
        return 'UserTask'
      } else {
        return 'WorkflowElement'
      }
    }
  }
}
</script>

<style scoped>
.network {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  border-radius: 5px;
  align-content: center;
}

.activity-props {
  padding-top: 2px;
  border-radius: 5px;
}
</style>
